import ActionConfirmationDialog from './ActionConfirmationDialog.view';

export default ActionConfirmationDialog;
